<template>
    <common-modal v-if="isOpen" @close="emitEvent({ name: 'close' })">
        <common-content-spacer height="medium">
            <common-content-wrapper width="large">
                <check-password-form
                    @edit-patient-enable="editPatientEnable"
                    @cancel="emitEvent({ name: 'close' })"
                ></check-password-form>
            </common-content-wrapper>
        </common-content-spacer>
    </common-modal>
</template>

<script>
    import CheckPasswordForm from 'components/forms/patient/CheckPasswordForm'
    export default {
        components: { CheckPasswordForm },

        props: {
            isOpen: { type: Boolean, required: true },
        },

        methods: {
            editPatientEnable() {
                this.emitEvent({ name: 'edit-patient' })
            },
        },
    }
</script>
